import {MenuProps} from "antd";
import {GiInnerSelf} from "react-icons/gi";
import {SiAbbott, SiCrehana, SiWebmoney} from "react-icons/si";
import React from "react";

const items: MenuProps['items'] = [
    {
        label: 'Sol·lucionat amb company/a',
        key: '1',
        icon: <GiInnerSelf/>,
    },
    {
        label: 'Sol·lucionat buscant apunts o internet',
        key: '2',
        icon: <SiWebmoney/>,
    },
    {
        label: 'Sol·lucionat per explicació general professor/a',
        key: '3',
        icon: <SiAbbott/>,
    },
    {
        label: 'Sortir de cua per altres motius',
        key: '4',
        icon: <SiCrehana/>,
    }
];

export default items;